import React from 'react';

import axios from 'axios';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { withStyles } from '@material-ui/core/styles';

import Shared from '../Shared/Shared';
import PopoverComponentLevel from './Component/PopoverComponentLevel';
import PopoverComponentRain from './Component/PopoverComponentRain';
import PopoverComponentBattery from './Component/PopoverComponentBattery';
import FooterComponent from '../Shared/Component/FooterComponent';

import { Config } from '../../Config';
import '../../index.css';

const styles = theme => ({
    paperTable: {
        maxWidth: '90vw',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
    },
    table: {
        minWidth: 650,
        "& .MuiTableCell-root": {
            border: "1px solid rgba(224, 224, 224, 1)"
        }
    },
    tableRow: {
        backgroundColor: '#0A0A7E'
    },
    tableRowText: {
        color: theme.palette.common.white,
        fontWeight: 'bold'
    },
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
    paper_2: {
        maxWidth: '80vw',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
    },
    imgLabel: {
        width: '30px',
        height: '30px',
        verticalAlign: 'middle'
    },
    imgTable: {
        width: '20px',
        height: '20px',
        verticalAlign: 'middle',
    },
    stickyPaperTable: {
        position: 'sticky',
        top: '0px',
        maxWidth: '90vw',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
    }
})

class Listing extends React.Component {
    constructor() {
        super()
        this.state = {
            data_1: [],
            data_2: [],
            data_3: [],
            data_4: [],
            data_5: [],

            hover_active: [{
                'name': '',
                'value_1': '',
                'value_2': '',
                'value_3': ''
            }],

            open_1: false,
            open_2: false,
            open_3: false,
            open_4: false,
            open_5: false,

            //rain popover
            open_rain_1: false,
            open_rain_2: false,
            open_rain_3: false,
            open_rain_4: false,
            open_rain_5: false,

            //battery popover
            open_battery_1: false,
            open_battery_2: false,
            open_battery_3: false,
            open_battery_4: false,
            open_battery_5: false,

            anchorE1: null,

            loading: false,

            today_date: '',
            ytd_date: '',
            yytd_date: '',
        }
    }

    componentDidMount() {
        this.setState({ loading: true })
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        var yesterday = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
        var dd_yesterday = String(yesterday.getDate()).padStart(2, '0');
        var mm_yesterday = String(yesterday.getMonth() + 1).padStart(2, '0');
        var yyyy_yesterday = yesterday.getFullYear();

        var twoDaysAgo = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24 * 2);
        var dd_twoDaysAgo = String(twoDaysAgo.getDate()).padStart(2, '0');
        var mm_twoDaysAgo = String(twoDaysAgo.getMonth() + 1).padStart(2, '0');
        var yyyy_twoDaysAgo = twoDaysAgo.getFullYear();

        today = dd + '-' + mm + '-' + yyyy;
        yesterday = dd_yesterday + '-' + mm_yesterday + '-' + yyyy_yesterday;
        twoDaysAgo = dd_twoDaysAgo + '-' + mm_twoDaysAgo + '-' + yyyy_twoDaysAgo;
        this.setState({
            today_date: today,
            ytd_date: yesterday,
            yytd_date: twoDaysAgo
        })

        this.fetchData()
        this.fetchDataInterval = setInterval(() => this.fetchIntervalData(), 300000)
        this.blinkInterval = setInterval(() => this.blink(), 1000)
    }

    componentWillUnmount() {
        clearInterval(this.fetchDataInterval)
        clearInterval(this.blinkInterval)
    }

    blink = () => {
        this.setState({ visible: !this.state.visible })
    }

    fetchData = () => {
        axios.get(Config() + "/listing/get")
        .then(async response => {
            if (response.data[0] === "OK") {
                for (var i = 0; i < response.data[1].length; i++) {
                    await this.fetchStationData(response.data[1][i])
                }
            }
        })
    }

    fetchStationData = async(node_data) => {
        axios.post(Config() + "/listing/get/station", {
            'node_id': node_data["ID"],
            'node_name': node_data["Name"]
        })
        .then(response => {
            if (response.data[0] === "OK") {
                //Append the station data to data array
                if (response.data[2] === "rainfall") {
                    response.data[1].idx = this.state.data_5.length
                    this.setState(prevState => ({
                        data_5: [...prevState.data_5, response.data[1]]
                    }))
                }
                
                else if (response.data[2] === "water_level") {
                    response.data[1].idx = this.state.data_4.length
                    this.setState(prevState => ({
                        data_4: [...prevState.data_4, response.data[1]]
                    }))
                }

                else if (response.data[2] === 'water_level&flow') {
                    response.data[1].idx = this.state.data_2.length
                    this.setState(prevState => ({
                        data_2: [...prevState.data_2, response.data[1]]
                      }))
                }
                
                else if (response.data[2] === 'water_level&rainfall') {
                    response.data[1].idx = this.state.data_3.length
                    this.setState(prevState => ({
                        data_3: [...prevState.data_3, response.data[1]]
                    }))
                }

                else {
                    response.data[1].idx = this.state.data_2.length
                    this.setState(prevState => ({
                        data_2: [...prevState.data_2, response.data[1]]
                      }))
                }
            }
        })
    }

    fetchIntervalData = () => {
        axios.get(Config() + "/listing/get")
        .then(async response => {
            if (response.data[0] === "OK") {
                for (var i = 0; i < response.data[1].length; i++) {
                    await this.fetchIntervalStationData(response.data[1][i])
                }
            }
        })
    }

    fetchIntervalStationData = async(node_data) => {
        axios.post(Config() + "/listing/get/station", {
            'node_id': node_data["ID"],
            'node_name': node_data["Name"]
        })
        .then(response => {
            if (response.data[0] === "OK") {
                //Append the station data to data array
                if (response.data[2] === "rainfall") {
                    let index = this.state.data_5.findIndex(obj => obj.node_id === response.data[1].node_id)
                    let items = [...this.state.data_5]
                    let item = {...items[index]}
                    response.data[1].idx = index
                    item = response.data[1]
                    items[index] = item
                    this.setState({data_5: items})
                }
                
                else if (response.data[2] === "water_level") {
                    let index = this.state.data_4.findIndex(obj => obj.node_id === response.data[1].node_id)
                    let items = [...this.state.data_4]
                    let item = {...items[index]}
                    response.data[1].idx = index
                    item = response.data[1]
                    items[index] = item
                    this.setState({data_4: items})
                }

                else if (response.data[2] === 'water_level&flow') {
                    let index = this.state.data_2.findIndex(obj => obj.node_id === response.data[1].node_id)
                    let items = [...this.state.data_2]
                    let item = {...items[index]}
                    response.data[1].idx = index
                    item = response.data[1]
                    items[index] = item
                    this.setState({data_2: items})
                }
                
                else if (response.data[2] === 'water_level&rainfall') {
                    let index = this.state.data_3.findIndex(obj => obj.node_id === response.data[1].node_id)
                    let items = [...this.state.data_3]
                    let item = {...items[index]}
                    response.data[1].idx = index
                    item = response.data[1]
                    items[index] = item
                    this.setState({data_3: items})
                }

                else {
                    response.data[1].idx = this.state.data_2.length
                    let index = this.state.data_2.findIndex(obj => obj.node_id === response.data[1].node_id)
                    let items = [...this.state.data_2]
                    let item = {...items[index]}
                    response.data[1].idx = index
                    item = response.data[1]
                    items[index] = item
                    this.setState({data_2: items})
                }
            }
        })
    }

    handlePopoverOpen = (event, idx) => {
        let array = [
            {
                'name': this.state.data_1[idx]['col_1'],
                'value_1': this.state.data_1[idx]['level_popover_list'][0]['alert'],
                'value_2': this.state.data_1[idx]['level_popover_list'][0]['warning'],
                'value_3': this.state.data_1[idx]['level_popover_list'][0]['danger'],
            }
        ]
        this.setState({
            open_1: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handlePopoverOpen_2 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_2[idx]['col_1'],
                'value_1': this.state.data_2[idx]['level_popover_list'][0]['alert'],
                'value_2': this.state.data_2[idx]['level_popover_list'][0]['warning'],
                'value_3': this.state.data_2[idx]['level_popover_list'][0]['danger'],
            }
        ]
        this.setState({
            open_2: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handlePopoverOpen_3 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_3[idx]['col_1'],
                'value_1': this.state.data_3[idx]['level_popover_list'][0]['alert'],
                'value_2': this.state.data_3[idx]['level_popover_list'][0]['warning'],
                'value_3': this.state.data_3[idx]['level_popover_list'][0]['danger'],
            }
        ]
        this.setState({
            open_3: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handlePopoverOpen_4 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_4[idx]['col_1'],
                'value_1': this.state.data_4[idx]['level_popover_list'][0]['alert'],
                'value_2': this.state.data_4[idx]['level_popover_list'][0]['warning'],
                'value_3': this.state.data_4[idx]['level_popover_list'][0]['danger'],
            }
        ]
        this.setState({
            open_4: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handlePopoverOpen_5 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_5[idx]['col_1'],
                'value_1': this.state.data_5[idx]['level_popover_list'][0]['alert'],
                'value_2': this.state.data_5[idx]['level_popover_list'][0]['warning'],
                'value_3': this.state.data_5[idx]['level_popover_list'][0]['danger'],
            }
        ]
        this.setState({
            open_5: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    //rain popover
    handleRainPopoverOpen = (event, idx) => {
        let array = [
            {
                'name': this.state.data_1[idx]['col_1'],
                'value_1': this.state.data_1[idx]['rain_popover_list'][0]['storm_rain'],
                'value_2': this.state.data_1[idx]['rain_popover_list'][0]['heavy_rain'],
            }
        ]
        this.setState({
            open_rain_1: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleRainPopoverOpen_2 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_2[idx]['col_1'],
                'value_1': this.state.data_2[idx]['rain_popover_list'][0]['storm_rain'],
                'value_2': this.state.data_2[idx]['rain_popover_list'][0]['heavy_rain'],
            }
        ]
        this.setState({
            open_rain_2: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleRainPopoverOpen_3 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_3[idx]['col_1'],
                'value_1': this.state.data_3[idx]['rain_popover_list'][0]['storm_rain'],
                'value_2': this.state.data_3[idx]['rain_popover_list'][0]['heavy_rain'],
            }
        ]
        this.setState({
            open_rain_3: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleRainPopoverOpen_4 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_4[idx]['col_1'],
                'value_1': this.state.data_4[idx]['rain_popover_list'][0]['storm_rain'],
                'value_2': this.state.data_4[idx]['rain_popover_list'][0]['heavy_rain'],
            }
        ]
        this.setState({
            open_rain_4: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleRainPopoverOpen_5 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_5[idx]['col_1'],
                'value_1': this.state.data_5[idx]['rain_popover_list'][0]['storm_rain'],
                'value_2': this.state.data_5[idx]['rain_popover_list'][0]['heavy_rain'],
            }
        ]
        this.setState({
            open_rain_5: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    //battery popover
    handleBatteryPopoverOpen = (event, idx) => {
        let array = [
            {
                'name': this.state.data_1[idx]['col_1'],
                'value_1': this.state.data_1[idx]['battery_popover_list'][0]['battery'],
            }
        ]
        this.setState({
            open_battery_1: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleBatteryPopoverOpen_2 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_2[idx]['col_1'],
                'value_1': this.state.data_2[idx]['battery_popover_list'][0]['battery'],
            }
        ]
        this.setState({
            open_battery_2: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleBatteryPopoverOpen_3 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_3[idx]['col_1'],
                'value_1': this.state.data_3[idx]['battery_popover_list'][0]['battery'],
            }
        ]
        this.setState({
            open_battery_3: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleBatteryPopoverOpen_4 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_4[idx]['col_1'],
                'value_1': this.state.data_4[idx]['battery_popover_list'][0]['battery'],
            }
        ]
        this.setState({
            open_battery_4: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handleBatteryPopoverOpen_5 = (event, idx) => {
        let array = [
            {
                'name': this.state.data_5[idx]['col_1'],
                'value_1': this.state.data_5[idx]['battery_popover_list'][0]['battery'],
            }
        ]
        this.setState({
            open_battery_5: true, anchorE1: event.currentTarget,
            hover_active: array
        })
    }

    handlePopoverClose = () => {
        this.setState({
            open_1: false,
            open_2: false,
            open_3: false,
            open_4: false,
            open_5: false,

            open_rain_1: false,
            open_rain_2: false,
            open_rain_3: false,
            open_rain_4: false,
            open_rain_5: false,

            open_battery_1: false,
            open_battery_2: false,
            open_battery_3: false,
            open_battery_4: false,
            open_battery_5: false,

            anchorE1: null
        })
    }

    render() {
        const { classes } = this.props
        return (
            <div className="background">
                <Shared />

                {this.state.data_1.length === 0 && this.state.data_2.length === 0 &&
                    this.state.data_3.length === 0 && this.state.data_4.length === 0 &&
                    this.state.data_5.length === 0 ?

                    <Paper className={classes.paperTable}>
                        <Typography
                            style={{ textAlign: 'center', padding: '1rem', fontWeight: 'bold' }}>
                            {this.state.loading ?
                                <p>Fetching data, this might take a while...</p>
                                :
                                <p>No data available...</p>
                            }

                        </Typography>
                    </Paper>

                    :

                    <React.Fragment>
                        {/* this is where the actual table body is */}
                        <Paper className={classes.paperTable}>
                            <TableContainer>
                                <Table className={classes.table} size="small">
                                <TableHead>
                                        <TableRow>
                                            <TableCell rowSpan={2} align="center" style={{ width: '12%', fontWeight: 'bold' }}>Station Name</TableCell>
                                            <TableCell rowSpan={2} align="center" style={{ width: '8%', fontWeight: 'bold' }}>River Basin</TableCell>
                                            <TableCell rowSpan={2} align="center" style={{ width: '10%', fontWeight: 'bold' }}>Date Time<br />(Last&nbsp;Updated)</TableCell>
                                            <TableCell rowSpan={2} align="center" style={{ width: '5%', fontWeight: 'bold' }}>Water Level<br />(m)</TableCell>
                                            <TableCell colSpan={5} align="center" style={{ width: '50%', fontWeight: 'bold' }}>Rain<br />(mm)</TableCell>
                                            <TableCell rowSpan={2} align="center" style={{ width: '5%', fontWeight: 'bold' }}>Flow<br />(m3/s)</TableCell>
                                            <TableCell rowSpan={2} align="center" style={{ width: '5%', fontWeight: 'bold' }}>Pump Status <br />(ON/OFF)</TableCell>
                                            <TableCell rowSpan={2} align="center" style={{ width: '5%', fontWeight: 'bold' }}>Battery<br />(v)</TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" style={{ width: '10%', fontWeight: 'bold' }}>{this.state.today_date}</TableCell>
                                            <TableCell align="center" style={{ width: '10%', fontWeight: 'bold' }}>{this.state.ytd_date}</TableCell>
                                            <TableCell align="center" style={{ width: '10%', fontWeight: 'bold' }}>{this.state.yytd_date}</TableCell>
                                            <TableCell align="center" style={{ width: '10%', fontWeight: 'bold' }}>Current Month <br /> Total Rainfall</TableCell>
                                            <TableCell align="center" style={{ width: '10%', fontWeight: 'bold' }}>Last Month <br /> Total Rainfall</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* <TableRow className={classes.tableRow}>
                                        <TableCell colSpan={11} className={classes.tableRowText}>
                                            Water Level & Flow & Rainfall
                                        </TableCell>
                                    </TableRow>
                                    {this.state.data_1.map(x =>
                                        <TableRow key={x.idx}>
                                            <TableCell align="center">{x.col_1}</TableCell>
                                            <TableCell align="center">{x.col_2}</TableCell>
                                            <TableCell align="center">{x.col_3}</TableCell> */}

                                        {/* <TableCell align="center"
                                                onMouseEnter={e => this.handlePopoverOpen(e, x.idx)}
                                                onMouseLeave={this.handlePopoverClose}
                                                aria-owns={this.state.open_1 ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true">
                                                {x.col_4}
                                            </TableCell> */}

                                        {/* <PopoverComponent
                                                open={this.state.open_1}
                                                anchorE1={this.state.anchorE1}
                                                onClose={this.handlePopoverClose}
                                                data={this.state.hover_active} />

                                            <TableCell align="center"
                                                onMouseEnter={e => this.handlePopoverOpen(e, x.idx)}
                                                onMouseLeave={this.handlePopoverClose}
                                                aria-owns={this.state.open_1 ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true">
                                                {x.col_5}
                                            </TableCell>
                                            <TableCell align="center">{x.col_6}</TableCell>
                                            <TableCell align="center">{x.col_7}</TableCell>
                                            <TableCell align="center">{x.col_8}</TableCell> */}

                                        {/* <TableCell align="center">{x.col_9}</TableCell> */}

                                        {/* <TableCell align="center">{x.col_10}</TableCell>
                                            <TableCell align="center">{x.col_11}</TableCell>
                                            <TableCell align="center">
                                                {x.battery_alarm_indicator === "Low" ?
                                                    <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                        {this.state.visible ?
                                                            <React.Fragment>{x.col_12}</React.Fragment>
                                                            :
                                                            <React.Fragment>&nbsp;</React.Fragment>
                                                        }
                                                    </p>
                                                    :
                                                    <p>{x.col_12}</p>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )} */}

                                        <TableRow className={classes.tableRow}>
                                            <TableCell colSpan={12} className={classes.tableRowText}>
                                                Water Level & Flow
                                            </TableCell>
                                        </TableRow>

                                        {this.state.data_2.map(x =>
                                            <TableRow key={x.idx}>
                                                <TableCell align="center">{x.col_1}</TableCell>
                                                <TableCell align="center">{x.col_2}</TableCell>
                                                <TableCell align="center">{x.col_3}</TableCell>
                                                {/* <TableCell align="center"
                                                onMouseEnter={e => this.handlePopoverOpen_2(e, x.idx)}
                                                onMouseLeave={this.handlePopoverClose}
                                                aria-owns={this.state.open_2 ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true">
                                                {x.col_4}
                                            </TableCell> */}

                                                <PopoverComponentLevel
                                                    open={this.state.open_2}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handlePopoverOpen_2(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_2 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.col_5}
                                                </TableCell>

                                                <PopoverComponentRain
                                                    open={this.state.open_rain_2}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleRainPopoverOpen_2(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_rain_2 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.col_6}
                                                </TableCell>

                                                <TableCell align="center">{x.col_7}</TableCell>
                                                <TableCell align="center">{x.col_8}</TableCell>
                                                {/* <TableCell align="center">{x.col_9}</TableCell> */}

                                                <TableCell align="center">{x.col_13}</TableCell>
                                                <TableCell align="center">{x.col_14}</TableCell>

                                                <TableCell align="center">{x.col_10}</TableCell>
                                                <TableCell align="center">
                                                    {x.col_11 === "ON" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>

                                                        :

                                                        x.col_11 === "OFF" ?
                                                            <p style={{ fontWeight: 'bold', color: 'green' }}>
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                            </p>

                                                            :

                                                            <p>{x.col_11}</p>
                                                    }
                                                </TableCell>
                                                <PopoverComponentBattery
                                                    open={this.state.open_battery_2}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleBatteryPopoverOpen_2(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_battery_2 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.battery_alarm_indicator === "Low" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_12}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>
                                                        :
                                                        <p>{x.col_12}</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        <TableRow className={classes.tableRow}>
                                            <TableCell colSpan={12} className={classes.tableRowText}>
                                                Water Level & Rainfall
                                            </TableCell>
                                        </TableRow>

                                        {this.state.data_3.map(x =>
                                            <TableRow key={x.idx}>
                                                <TableCell align="center">{x.col_1}</TableCell>
                                                <TableCell align="center">{x.col_2}</TableCell>
                                                <TableCell align="center">{x.col_3}</TableCell>
                                                {/* <TableCell align="center"
                                                onMouseEnter={e => this.handlePopoverOpen_3(e, x.idx)}
                                                onMouseLeave={this.handlePopoverClose}
                                                aria-owns={this.state.open_3 ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true">
                                                {x.col_4}
                                            </TableCell> */}

                                                <PopoverComponentLevel
                                                    open={this.state.open_3}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handlePopoverOpen_3(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_3 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.col_5}
                                                </TableCell>

                                                <PopoverComponentRain
                                                    open={this.state.open_rain_3}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleRainPopoverOpen_3(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_rain_3 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.col_6}
                                                </TableCell>

                                                <TableCell align="center">{x.col_7}</TableCell>
                                                <TableCell align="center">{x.col_8}</TableCell>
                                                {/* <TableCell align="center">{x.col_9}</TableCell> */}

                                                <TableCell align="center">{x.col_13}</TableCell>
                                                <TableCell align="center">{x.col_14}</TableCell>

                                                <TableCell align="center">{x.col_10}</TableCell>
                                                <TableCell align="center">
                                                    {x.col_11 === "ON" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>

                                                        :

                                                        x.col_11 === "OFF" ?
                                                            <p style={{ fontWeight: 'bold', color: 'green' }}>
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                            </p>

                                                            :

                                                            <p>{x.col_11}</p>
                                                    }
                                                </TableCell>
                                                <PopoverComponentBattery
                                                    open={this.state.open_battery_3}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleBatteryPopoverOpen_3(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_battery_3 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.battery_alarm_indicator === "Low" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_12}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>
                                                        :
                                                        <p>{x.col_12}</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        <TableRow className={classes.tableRow}>
                                            <TableCell colSpan={12} className={classes.tableRowText}>
                                                Water Level
                                            </TableCell>
                                        </TableRow>

                                        {this.state.data_4.map(x =>
                                            <TableRow key={x.idx}>
                                                <TableCell align="center">{x.col_1}</TableCell>
                                                <TableCell align="center">{x.col_2}</TableCell>
                                                <TableCell align="center">{x.col_3}</TableCell>
                                                {/* <TableCell align="center"
                                                onMouseEnter={e => this.handlePopoverOpen_4(e, x.idx)}
                                                onMouseLeave={this.handlePopoverClose}
                                                aria-owns={this.state.open_4 ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true">
                                                {x.col_4}
                                            </TableCell> */}

                                                <PopoverComponentLevel
                                                    open={this.state.open_4}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handlePopoverOpen_4(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_4 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.level_alarm_indicator === "Alert" ?
                                                        <p style={{ fontWeight: 'bold', color: 'green' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_5}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>
                                                        :
                                                        x.level_alarm_indicator === "Warning" ?
                                                            <p style={{ fontWeight: 'bold', color: 'orange' }}>
                                                                {this.state.visible ?
                                                                    <React.Fragment>{x.col_5}</React.Fragment>
                                                                    :
                                                                    <React.Fragment>&nbsp;</React.Fragment>
                                                                }
                                                            </p>
                                                            :
                                                            x.level_alarm_indicator === "Danger" ?
                                                                <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                                    {this.state.visible ?
                                                                        <React.Fragment>{x.col_5}</React.Fragment>
                                                                        :
                                                                        <React.Fragment>&nbsp;</React.Fragment>
                                                                    }
                                                                </p>
                                                                :
                                                                <p>{x.col_5}</p>
                                                    }
                                                </TableCell>

                                                <PopoverComponentRain
                                                    open={this.state.open_rain_4}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleRainPopoverOpen_4(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_rain_4 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.col_6}
                                                </TableCell>

                                                <TableCell align="center">{x.col_7}</TableCell>
                                                <TableCell align="center">{x.col_8}</TableCell>
                                                {/* <TableCell align="center">{x.col_9}</TableCell> */}

                                                <TableCell align="center">{x.col_13}</TableCell>
                                                <TableCell align="center">{x.col_14}</TableCell>

                                                <TableCell align="center">{x.col_10}</TableCell>
                                                <TableCell align="center">
                                                    {x.col_11 === "ON" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>

                                                        :

                                                        x.col_11 === "OFF" ?
                                                            <p style={{ fontWeight: 'bold', color: 'green' }}>
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                            </p>

                                                            :

                                                            <p>{x.col_11}</p>
                                                    }
                                                </TableCell>
                                                <PopoverComponentBattery
                                                    open={this.state.open_battery_4}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleBatteryPopoverOpen_4(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_battery_4 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.battery_alarm_indicator === "Low" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_12}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>
                                                        :
                                                        <p>{x.col_12}</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        <TableRow className={classes.tableRow}>
                                            <TableCell colSpan={12} className={classes.tableRowText}>
                                                Rainfall
                                            </TableCell>
                                        </TableRow>

                                        {this.state.data_5.map(x =>
                                            <TableRow key={x.idx}>
                                                <TableCell align="center">{x.col_1}</TableCell>
                                                <TableCell align="center">{x.col_2}</TableCell>
                                                <TableCell align="center">{x.col_3}</TableCell>
                                                {/* <TableCell align="center"
                                                onMouseEnter={e => this.handlePopoverOpen_5(e, x.idx)}
                                                onMouseLeave={this.handlePopoverClose}
                                                aria-owns={this.state.open_5 ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true">
                                                {x.col_4}
                                            </TableCell> */}

                                                <PopoverComponentLevel
                                                    open={this.state.open_5}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handlePopoverOpen_5(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_5 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.col_5}
                                                </TableCell>

                                                <PopoverComponentRain
                                                    open={this.state.open_rain_5}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleRainPopoverOpen_5(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_rain_5 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.rain_alarm_indicator === "Heavy Rain" ?
                                                        <p style={{ fontWeight: 'bold', color: 'orange' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_6}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>
                                                        :
                                                        <p>{x.col_6}</p>
                                                    }
                                                </TableCell>

                                                <TableCell align="center">{x.col_7}</TableCell>
                                                <TableCell align="center">{x.col_8}</TableCell>
                                                {/* <TableCell align="center">{x.col_9}</TableCell> */}

                                                <TableCell align="center">{x.col_13}</TableCell>
                                                <TableCell align="center">{x.col_14}</TableCell>

                                                <TableCell align="center">{x.col_10}</TableCell>
                                                <TableCell align="center">
                                                    {x.col_11 === "ON" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>

                                                        :

                                                        x.col_11 === "OFF" ?
                                                            <p style={{ fontWeight: 'bold', color: 'green' }}>
                                                                <React.Fragment>{x.col_11}</React.Fragment>
                                                            </p>

                                                            :

                                                            <p>{x.col_11}</p>
                                                    }
                                                </TableCell>

                                                <PopoverComponentBattery
                                                    open={this.state.open_battery_5}
                                                    anchorE1={this.state.anchorE1}
                                                    onClose={this.handlePopoverClose}
                                                    data={this.state.hover_active} />

                                                <TableCell align="center"
                                                    onMouseEnter={e => this.handleBatteryPopoverOpen_5(e, x.idx)}
                                                    onMouseLeave={this.handlePopoverClose}
                                                    aria-owns={this.state.open_battery_5 ? 'mouse-over-popover' : undefined}
                                                    aria-haspopup="true">
                                                    {x.battery_alarm_indicator === "Low" ?
                                                        <p style={{ fontWeight: 'bold', color: 'red' }}>
                                                            {this.state.visible ?
                                                                <React.Fragment>{x.col_12}</React.Fragment>
                                                                :
                                                                <React.Fragment>&nbsp;</React.Fragment>
                                                            }
                                                        </p>
                                                        :
                                                        <p>{x.col_12}</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </React.Fragment>
                }

                <Paper variant="outlined" elevation={3} className={classes.paper_2}>
                    <Grid container direction="row">
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <img src="http://hydrologywp.selfip.com/images/level_high_high_high.png" alt="label-critical"
                                className={classes.imgLabel} />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'red' }}>
                                Danger Level
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <img src="http://hydrologywp.selfip.com/images/level_high_high.png" alt="label-danger"
                                className={classes.imgLabel} />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'orange' }}>
                                Warning Level
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <img src="http://hydrologywp.selfip.com/images/level_high.png" alt="label-alert"
                                className={classes.imgLabel} />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green' }}>
                                Alert Level
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <img src="http://hydrologywp.selfip.com/images/morning_storm.png" alt="label-storm"
                                className={classes.imgLabel} />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'red' }}>
                                Storm Rain
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <img src="http://hydrologywp.selfip.com/images/morning_heavy.png" alt="label-storm"
                                className={classes.imgLabel} />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'orange' }}>
                                Heavy Rain
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <img src="http://hydrologywp.selfip.com/images/morning_mod.png" alt="label-storm"
                                className={classes.imgLabel} />
                            <Typography variant="caption" style={{ padding: '1rem', fontSize: '13px', color: 'green' }}>
                                Moderate Rain
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container direction="row" justifyContent="flex-end" style={{ paddingTop: '0.5rem' }}>
                        <Grid item xs={12} sm={12} md={6} lg={4} style={{ textAlign: 'right' }}>
                            <Typography variant="caption" style={{ fontSize: '13px', color: 'grey', fontStyle: 'italic' }}>
                                Note: This page will refresh every 5 minutes
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>

                <FooterComponent />
            </div>
        )
    }
}

export default withStyles(styles, { withTheme: true })(Listing);